<template>
    <div>
        <b-card-header>
            <b-nav card-header tabs>
                <b-nav-item :to="{name: 'projects.logs', params: {projectId}}">
                    {{ $t('Logs') }}
                </b-nav-item>

                <b-nav-item
                    :active="$route.name === 'projects.issues.show'"
                    :to="{name: 'projects.issues', params: {projectId}, query: {status: 'open'}}"
                >
                    {{ $t('Issues') }}

                    <b-badge v-if="issuesCount" variant="danger">
                        {{ issuesCount }}
                    </b-badge>
                </b-nav-item>
            </b-nav>
        </b-card-header>

        <router-view
            ref="childView"
            @update:issues_count="item.issues_count = $event"
        />
    </div>
</template>
<script>
    import {STATUS_OPEN} from "@/constants/issues";

    export default {
        name: 'ProjectAdministration',
        props: ['projectId'],
        data() {
            return {
                issuesCount: 0
            }
        },
        created() {
            this.fetchOpenIssuesCount();

            this.$echo.listen('issues', 'IssueResolved', this.fetchOpenIssuesCount);
        },
        methods: {
            fetchOpenIssuesCount() {
                this.axios.get('/api/issues', {
                    params: {
                        status: STATUS_OPEN,
                        count: true,
                        project_id: this.projectId
                    }
                }).then(({data}) => {
                    this.issuesCount = data;
                });
            }
        }
    }
</script>
